import store from '@/store';
import i18n from '@/i18n';
import api from '../../../api/organizations';
import * as types from './types';

export default {

  getOrganizations(context, params) {
    const searchRequest = params;
    if (searchRequest) {
      store.dispatch('application/startLoading');
      if (searchRequest.orgID === 0 || !searchRequest.orgID) {
        if (searchRequest.parentId) {
          delete searchRequest.parentId;
        }
        return api.getTopLevelOrganisations(searchRequest)
          .then((data) => {
            let newTotalPage = Math.ceil(data.count / searchRequest.limit);
            if (newTotalPage === 0) {
              newTotalPage = 1;
            }
            context.commit(types.GET_TOTALPAGES, newTotalPage);
            context.commit(types.GET_TOTALELMTS, data.count);
            context.commit(types.SET_ORGANIZATIONS, data.organizations);
            store.dispatch('application/finishLoading');
            return data;
          })
          .catch(() => {
            context.commit(types.GET_TOTALELMTS_FAILED);
            context.commit(types.GET_TOTALELMTS_FAILED);
            context.commit(types.SET_ORGANIZATIONS_FAILED);
            store.dispatch('application/finishLoading');
          });
      }
      return api.getOrganizations(searchRequest)
        .then((data) => {
          let newTotalPage = Math.ceil(data.count / searchRequest.limit);
          if (newTotalPage === 0) {
            newTotalPage = 1;
          }
          context.commit(types.GET_TOTALPAGES, newTotalPage);
          context.commit(types.GET_TOTALELMTS, data.count);
          context.commit(types.SET_ORGANIZATIONS, data.organizations);
          store.dispatch('application/finishLoading');
          return data;
        })
        .catch(() => {
          context.commit(types.GET_TOTALELMTS_FAILED);
          context.commit(types.GET_TOTALELMTS_FAILED);
          context.commit(types.SET_ORGANIZATIONS_FAILED);
          store.dispatch('application/finishLoading');
        });
    }
    return context.commit(types.SET_ORGANIZATIONS, []);
  },

  getOrganizationsTopLevel(context, searchRequest) {
    if (searchRequest) {
      store.dispatch('application/startLoading');
      return api.getOrganizationsTopLevel(searchRequest)
        .then((data) => {
          let newTotalPage = Math.ceil(data.count / searchRequest.limit);
          if (newTotalPage === 0) {
            newTotalPage = 1;
          }
          context.commit(types.GET_TOTALPAGES, newTotalPage);
          context.commit(types.GET_TOTALELMTS, data.count);
          context.commit(types.SET_ORGANIZATIONS, data.organizations);
          store.dispatch('application/finishLoading');
          return data;
        })
        .catch(() => {
          context.commit(types.GET_TOTALELMTS_FAILED);
          context.commit(types.GET_TOTALELMTS_FAILED);
          context.commit(types.SET_ORGANIZATIONS_FAILED);
          store.dispatch('application/finishLoading');
        });
    }
    return context.commit(types.SET_ORGANIZATIONS, []);
  },

  updateCurrentOrganization(context, id) {
    store.dispatch('application/startLoading');
    api.getOrganization(id).then((data) => {
      context.commit(types.SET_CURRENT_ORGA, data);
      store.dispatch('application/finishLoading');
    })
      .catch(() => {
        context.commit(types.SET_CURRENT_ORGA_FAILED);
        store.dispatch('application/finishLoading');
      });
  },

  getOrganization(context, id) {
    return api.getOrganization(id).then(data => data);
  },
  getDeskRhUsersByOrganization(context, id) {
    return api.getDeskRhUsersByOrganization(id);
  },
  getOrganizationAncestors(context, id) {
    return api.getOrganizationAncestors(id).then(data => data);
  },

  getDocType(context, id) {
    return api.getDocType(id);
  },

  getOrganizationEmployeesGroups(context, id) {
    return api.getOrganizationEmployeesGroups(id)
      .then(data => data);
  },

  getAllOrganizations(context, searchRequest) {
    store.dispatch('application/startLoading');
    const actualSearcRequest = {};
    for (let attrIndex = 0; attrIndex < Object.keys(searchRequest).length; attrIndex += 1) {
      actualSearcRequest[Object.keys(searchRequest)[attrIndex]] =
        searchRequest[Object.keys(searchRequest)[attrIndex]];
    }
    actualSearcRequest.limit = undefined;
    return api.getAllOrganizations(actualSearcRequest)
      .then((data) => {
        context.commit(types.SET_ALL_ORGANIZATIONS, data.organizations);
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => {
        context.commit(types.SET_ALL_ORGANIZATIONS_FAILED);
        store.dispatch('application/finishLoading');
      });
  },

  getStats(context) {
    store.dispatch('application/startLoading');
    return api.getStats()
      .then((data) => {
        context.commit(types.LOAD_STATS_SUCCESS, data.data);
        store.dispatch('application/finishLoading');
      })
      .catch(() => {
        context.commit(types.LOAD_ERROR);
        store.dispatch('application/finishLoading');
      });
  },

  getOrganizationBySiret(context, siret) {
    store.dispatch('application/startLoading');
    return api.getOrganizationBySiret(siret)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch((error) => {
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.find.siret.failure'),
        });
        store.dispatch('application/finishLoading');
        return Promise.reject(error);
      });
  },

  getAllOrgExceptChildren(context, searchRequest) {
    store.dispatch('application/startLoading');
    return api.getAllOrgExceptChildren(searchRequest)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  newOrganization(context, organization) {
    store.dispatch('application/startLoading');
    api.newOrganization(organization)
      .then((data) => {
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.creation.success'),
        });
        store.dispatch('application/finishLoading');
        context.dispatch('updateCurrentOrganization', data.data.data.organizationId);
      })
      .catch((error) => {
        let errorMessages = error.response.data.data.errors;
        errorMessages = errorMessages.map(x => `<li class="ed-list"> ${x} </li>`);
        errorMessages = `<ul> ${errorMessages} </ul>`;
        console.log(errorMessages);
        store.dispatch('application/openSnackbar', {
          message: errorMessages,
        });
        store.dispatch('application/finishLoading');
      });
  },

  updateOrganization(context, params) {
    store.dispatch('application/startLoading');
    return api.putOrganization(params.id, params.organization)
      .then(() => {
        context.commit(types.SET_ORGANIZATIONS, []);
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.update.success'),
        });
      })
      .catch(() => {
        context.commit(types.SET_ORGANIZATIONS_FAILED);
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.update.error'),
        });
      });
  },

  updateOrgTransmissionMode(context, params) {
    store.dispatch('application/startLoading');
    return api.updateOrgTransmissionMode(params)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.update.success'),
        });
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.update.error'),
        });
      });
  },

  updateOrgReceptionMode(context, params) {
    store.dispatch('application/startLoading');
    return api.updateOrgReceptionMode(params)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.update.success'),
        });
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.messages.update.error'),
        });
      });
  },

  deleteOrganization(context, id) {
    api.deleteOrganization(id);
  },

  getOrgConf(context, id) {
    store.dispatch('application/startLoading');
    return api.getOrgConf(id)
      .then((response) => {
        store.dispatch('application/finishLoading');
        return response;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.conf.get.failure'),
        });
      });
  },

  updateOrgConf(context, params) {
    store.dispatch('application/startLoading');
    return api.updateOrgConf(params)
      .then((response) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.conf.update.succes'),
        });
        return response;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('organizations.conf.update.failure'),
        });
      });
  },

  setPathList({ commit }, list) {
    commit(types.SET_PATH, list);
  },

  addToPathList({ commit }, item) {
    commit(types.ADD_TO_PATH, item);
  },

  slicePathList({ commit }, index) {
    commit(types.SLICE_PATH, index);
  },

  spliceBreadcrumb({ commit }, params) {
    commit(types.SPLICE_PATH, params);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/actions.js